import React from 'react'

const PotentialInput = ({value, handleOnChange}) => {

    const inputStyle = {
        border: '1px solid black',
        borderRadius: 0,
        outline: 'none'
    }

    return (
        <input type='text' style={inputStyle} value={value} onChange={handleOnChange}/>
    )
}

export default PotentialInput